import PropTypes from "prop-types";
import React from "react";

import { PermissionShape,ProductShape } from "../../policies/proptypes";

const PermissionsListGroup = ({ product, permissions }) => {
  const permissionItems = permissions.map(permission => (
    <li className="p-list__item" key={permission.$uri}>
      <div style={{ padding: ".3125rem .5rem .3125rem 1rem" }}>
        {permission.summary}
      </div>
    </li>
  ));

  return (
    <li className="p-list__item">
      <div style={{ padding: ".3125rem .5rem" }}>{product.name}</div>
      <ul className="p-list">{permissionItems}</ul>
    </li>
  );
};

PermissionsListGroup.propTypes = {
  product: ProductShape.isRequired,
  permissions: PropTypes.arrayOf(PermissionShape).isRequired
};

export default PermissionsListGroup;
